export const Config = {
    apiUrl: '/consumerspending/api'
    //apiUrl: 'http://localhost/SpendingTrend'
}